export default __webpack_public_path__ + "static/media/EE.a30d26eb.svg";